import {
    PublicCourse,
    PublicEducator,
    PublicOccurrence,
} from '@cademy-package/sdk-component-types';

type getWaitlistUrlExtras = {
    request?: boolean;
    group?: boolean;
};

export type GetWaitlistUrlProps = {
    course: PublicCourse;
    educator: PublicEducator;
    isMarketplace: boolean;
    occurrence?: PublicOccurrence;
    extras?: getWaitlistUrlExtras;
    isEmbed: boolean;
};

export const getWaitlistUrl = ({
    course,
    educator,
    isEmbed,
    isMarketplace,
    extras,
    occurrence,
}: GetWaitlistUrlProps): string => {
    const parts = [
        `educator_slug=${educator.slug}`,
        `educator_name=${encodeURIComponent(educator.name)}`,
        `course_ref=${course.slug}`,
        `course_name=${encodeURIComponent(course.name)}`,
    ];

    if (occurrence) {
        parts.push(`occurrence=${occurrence._id}`);
    }

    if (extras?.request === true) {
        if (course.type !== 'on-request') {
            parts.push('request=true');
        }
    }
    if (extras?.group === true) {
        if (course.type !== 'on-request') {
            parts.push('request_type=group');
        }
    }

    if (isMarketplace) {
        return `/${educator.slug}/enquiry?type=waitlist&${parts.join('&')}`;
    }

    if (isEmbed) {
        const [protocol, host] = (process.env.NEXT_PUBLIC_MARKETPLACE_URL || '').split('://');
        return `${protocol}://${educator.slug}.${host}/enquiry?type=waitlist&${parts.join('&')}`;
    }

    return `/enquiry?type=waitlist&${parts.join('&')}`;
};
